export const SESSION_DURATION_MS = 24 * 60 * 60 * 1000 // 24 hours in milliseconds

export const SESSION_COOKIE_KEY = 'session'
export const SUPER_ADMIN_SESSION_COOKIE_KEY = 'super_admin_session'

export type SessionType = 'super_admin_session' | 'session'
